export default {
  isAuthenticated: state => !!state.user,
  isSuperUser: (state, getters) =>
    getters.isAuthenticated ? state.user.is_superuser : false,
  hasSpecialPermissions: (state, getters) =>
    getters.isAuthenticated ? state.user.user_permissions.length > 0 : false
};
